import { Sparkles } from 'lucide-react'

export default function PatientStub({ title, note }) {
  return (
    <div>
      {title && <h2 className="text-[19px] font-semibold text-slate-900 tracking-tight mb-4">{title}</h2>}
      <div className="rounded-2xl border border-dashed border-slate-200 bg-white/60 p-12 flex flex-col items-center justify-center text-center">
        <div className="w-10 h-10 rounded-xl bg-brand-50 text-brand-600 flex items-center justify-center mb-3">
          <Sparkles size={18} strokeWidth={1.75} />
        </div>
        <div className="text-[14px] text-slate-500">
          {note || 'เมนูนี้ยังไม่ได้สร้าง — จะพัฒนาในขั้นถัดไป'}
        </div>
      </div>
    </div>
  )
}
